export default __webpack_public_path__ + "static/media/Himanshu.bdc6abee.PNG";